<template>
  <div class="order-purchase-number">
    <v-radio-group
      v-model="localValue.shipping.handler.handler"
    >
      <v-row
        v-for="(option, i) in shippingOptions"
        :key="i"
      >
        <v-col>
          <v-radio
            :value="option"
            :label="option.text"
          />
        </v-col>
      </v-row>
    </v-radio-group>
  </div>
</template>

<script>
import ModelableMixin from '../../../../mixins/modelable';

export default {
  name: 'Handler',

  mixins: [
    ModelableMixin,
  ],

  computed: {
    shippingOptions() {
      return [
        { text: 'Komacut handles the shipment' },
        { text: 'Client organizes the shipment with their own forwarder' },
        { text: 'Komacut organizes the shipment with client forwarder' },
      ];
    },
  },
};
</script>

<style scoped>

</style>
